<template>
  <div id="app">
    <!--导航条-->
    <gheader></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav></grednav>
    <!--主要内容展示-->
    <div class="row-content">
      <div class="main-width">
        <div class="company-info pull-left">
          <div class="form-group basic-info">
            <div class="basic-info-content">
              <p>
                <span class="title">企业实名认证</span>
                <span>
                  <img src="static/imgs/zizhi.png" alt />
                </span>
              </p>
              <p>
                <span class="title">采购结算</span>
                <span>
                  <img src="static/imgs/zhifu.png" alt />
                </span>
              </p>
              <p>
                <span class="title">所在地：</span>
                {{address}}
              </p>
              <p>
                <span class="title">累计询价单：</span>
                {{infos.enquiryCount}}
              </p>
              <p>
                <span class="title">招投标：</span>
                {{infos.bidCount}}
              </p>
              <p>
                <span class="title">招募供应商：</span>
                {{infos.supCount}}
              </p>
              <!--<p><span class="title">在线采购金额：</span>{{infos.bidMoney}}</p>-->
              <!--<p><span class="title">在线采购数：</span>{{infos.purCount}}</p>-->
              <button class="btn btn-collect pull-left">
                <span>
                  <img src="static/imgs/guanzhu.png" alt />
                </span>&nbsp;收藏内容
              </button>
              <button class="btn btn-purchase pull-right">
                <span>
                  <img src="static/imgs/dingyue.png" alt />
                </span>&nbsp;采购订阅
              </button>
            </div>
          </div>
        </div>
        <div class="contact-info pull-right" style="margin-bottom: 100px;">
          <div class="form-group shanghai" style="height: 520px;">
            <p>
              <span>{{companyname}}</span>
            </p>
            <div>
              <p>
                <span>电话：</span>
                {{telephone}}
              </p>
              <p>
                <span>地址：</span>
                {{address}}
              </p>
              <!-- <div class="address-box" style="padding-top:50px;text-align:center;">
                <img src="static/imgs/szMap.png" alt="">
              </div>-->
            </div>
            <p>
              <span>{{companyMaterialName}}</span>
            </p>
            <div>
              <p>
                <span>电话：</span>
                {{MaterialTelephone}}
              </p>
            </div>
            <p>
              <span>{{companyByName}}</span>
            </p>
            <div>
              <p>
                <span>电话：</span>
                {{ByTelephone}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--footer-->
    <gfooter id="contact-footer"></gfooter>
  </div>
</template>

<script>
/*eslint-disable*/
import gheader from "components/G-header";
import glogo from "components/G-logo";
import grednav from "components/G-rednav";
import gsupplier from "components/G-supplier";
import gfooter from "components/G-footer";
import lnav from "components/L-nav";
import map1 from "components/map1";
import map2 from "components/map2";
import map3 from "components/map3";
import { apiLinks } from "../../api/links";

export default {
  name: "app",
  components: {
    gheader,
    glogo,
    grednav,
    gsupplier,
    gfooter,
    lnav,
    map1,
    map2,
    map3,
  },
  data() {
    return {
      logourl: apiLinks.logourl,
      companyname: apiLinks.companyfullname,
      companyMaterialName: apiLinks.companyMaterialName,
      companyByName: apiLinks.companyByName,
      MaterialTelephone: apiLinks.MaterialTelephone,
      ByTelephone: apiLinks.ByTelephone,
      telephone: apiLinks.telephone,
      address: apiLinks.address,
      links: {
        title: "友情链接",
        content: [
          "南方水泥官方网站",
          "中国建筑材料集团有限公司",
          "中国建材股份有限公司",
          "南方水泥有限公司成员企业",
        ],
      },
      infos: {
        enquiryCount: "登录后可见",
        bidCount: "登录后可见",
        supCount: "登录后可见",
        bidMoney: "登录后可见",
        purCount: "登录后可见",
      },
    };
  },
  mounted() {
    let url = apiLinks.contact;
    //后续再改
    if (window.localStorage.user) {
      this.$http.jsonp(url, []).then(
        function (response) {
          this.infos = response.data[0]["result"];
          this.infos.enquiryCount += "条";
          this.infos.bidCount += "次";
          this.infos.supCount += "次";
          this.infos.bidMoney += "元";
          this.infos.purCount += "次";
        },
        function (response) {}
      );
    }
  },
};
</script>
<style>
@import "contact.css";
</style>



// WEBPACK FOOTER //
// contact.vue?068b1f0c